
<template>
    <div>
        <app-table
			class="is-not-selectable no-main-list"
			:columns="columns"
			:filter-columns="false"
			:main-list="true"
			:rows="rows"
			title="PROCESOS"
			btn-actions
			:items-quantity="totalItemsVisible"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			:last-page="lastPage"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search-event', $event)"
			@changeSort="$emit('changeSort', $event)"
			@changeColor="changeColor"
			>
			<template slot="action">
				<v-btn
					class="btn-action-process"
					@click="newProcess">
					Nuevo Proceso
				</v-btn>
			</template>
			<template slot="rows" slot-scope="props">
				<td style="width: 45%; text-align: left; padding-left: 50px;" v-show="showRow(columns, 1)">{{ props.row.name }}</td>
				<td v-show="showRow(columns, 2)">{{ props.row.startDate | formatDate }}</td>
				<td v-show="showRow(columns, 3)">{{ props.row.endDate | formatDate }}</td>
				<td v-show="showRow(columns, 4)">{{ props.row.totalEmpl }} / {{ props.row.numEvaluators }}</td>
				<td v-show="showRow(columns, 5)">
					<template>
						<app-tooltip-button
							icon="circle"
							:color="props.row.status === 1 ? 'secondary' : 'success'"
							:text="props.row.status === 1 ? 'En Proceso' : 'Publicado'"
						/>
					</template>
				</td>
				<td v-show="showRow(columns, 6)" @click.stop="stopClick">
					<v-layout wrap>
						<app-tooltip-button
							icon="remove_red_eye"
							size="20"
							text="Detalle"
							color="primary"
							@click-icon="$emit('click-icon', { action: 'report', row: props.row })"
						/>
						<app-tooltip-button
							img="/static/img/download.svg"
							text="Descargar"
							@click-icon="$emit('click-icon', { action: 'download', row: props.row, type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/edit.svg`"
							text="Editar"
							@click-icon="$emit('click-icon', { action: 'edit', row: props.row })"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/delete-button.svg`"
							text="Eliminar"
							color="info"
							:disabled="props.row.status === 2"
							@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
						/>
					</v-layout>
				</td>
			</template>
		</app-table>
    </div>
</template>

<script >

function created() {
}

function newProcess() {
	this.$store.dispatch('evaluation360/assignProcess', null);
	this.$store.dispatch('evaluation360/updateEmployeesByArea', []);
	this.$store.dispatch('evaluation360/saveJobIds', []);
	this.goTo('process-configuration-process');
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'NOMBRE DEL PROCESO',
				value: 'name',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'name',
				color: 'gray',
			},
			{
				id: 2,
				name: 'FECHA DE INICIO',
				value: 'startDate',
				visible: true,
				checked: true,
			},
			{
				id: 3,
				name: 'FECHA DE FIN',
				value: 'endDate',
				visible: true,
				checked: true,
			},
			{
				id: 4,
				name: 'EVALUADORES',
				value: 'evaluators',
				visible: true,
				checked: true,
			},
			{
				id: 5,
				name: 'ESTADO',
				value: 'state',
				visible: true,
				checked: true,
			},
			{
				id: 6,
				name: 'ACCIONES',
				visible: true,
				checked: true,
			},
		],
	};
}

export default {
	name: 'process-list',
	data,
	created,
	components: {
	},
	methods: {
		newProcess,
		changeColor,
	},
	props: {
		rows: {
			default: () => [],
			type: Array,
		},
		currentPage: [Number, String],
		lastPage: [Number, String],
		totalItems: [Number, String],
		totalItemsVisible: [Number, String],
		flagNum: [Number],
	},
	watch: {
		flagNum: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.columns.forEach((c, index) => {
						this.$set(this.columns, index, { ...c, color: 'gray' });
					});
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-action-process {
	border-radius: 28.5px !important;
	box-shadow: none !important;
	color: color(white) !important;
	height: 40px !important;
	margin: 0px;
	text-transform: none !important;
	font-family: map-get($fonts, bold);
	width: 140px !important;
	background-color: map-get($colors, green-dark) !important;

	&:hover {
	background-color: map-get($colors, orange-dark) !important;
	}
	.v-btn__content {
		color: color(white) !important;
		// font-family: map-get($fonts, bold);
		padding: 0px;

		img {
			height: auto;
			margin-right: 19px;
		}
	}

	&:not(.btn-detail-close) {
		.v-btn__content {
			font-size: size(medium);
		}
	}

	&.text-large {
		.btn__content {
			font-family: map-get($fonts, open-bold);
			font-size: map-get($sizes, small);
		}
	}
	&.v-btn--disabled {
		background: #9b9b9b !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-list.vue